import { Injectable } from '@angular/core';
import { ApiService } from '@core/providers/http/api.service';
import { Observable } from 'rxjs';
import { HttpContext } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class EnumService {
  private readonly path = 'bolsa/api/enums';

  constructor(private apiService: ApiService) {}

  getAllCoberturaEnum(): Observable<any> {
    return this.apiService.get(`${this.path}/getAllCoberturaEnum`);
  }

  getAllGeneroEnum(): Observable<any> {
    return this.apiService.get(`${this.path}/getAllGeneroEnum`);
  }

  getAllEstadoBolsaCursoEnum(): Observable<any> {
    return this.apiService.get(`${this.path}/getAllEstadoBolsaCursoEnum`);
  }

  getAllEstadoMatriculaEnum(): Observable<any> {
    return this.apiService.get(`${this.path}/getAllEstadoMatriculaEnum`);
  }

  getAllNaturezaInstituicaoEnum(): Observable<any> {
    return this.apiService.get(`${this.path}/getAllNaturezaInstituicaoEnum`);
  }

  getAllParecerSolicitacaoEnum(): Observable<any> {
    return this.apiService.get(`${this.path}/getAllParecerSolicitacaoEnum`);
  }

  getAllTipoBolsaEnum(): Observable<any> {
    return this.apiService.get(`${this.path}/getAllTipoBolsaEnum`);
  }

  getAllTipoInstituicaoEnum(): Observable<any> {
    return this.apiService.get(`${this.path}/getAllTipoInstituicaoEnum`);
  }

  getAllEstadoAcademicoEnum(): Observable<any> {
    return this.apiService.get(`${this.path}/getAllEstadoAcademicoEnum`);
  }

  getAllEstadoBolsaEnum(): Observable<any> {
    return this.apiService.get(`${this.path}/getAllEstadoBolsaEnum`);
  }

  getAllEstadoCivilEnum(): Observable<any> {
    return this.apiService.get(`${this.path}/getAllEstadoCivilEnum`);
  }

  getAllEstadoSolicitacaoRenovacaoEnum(): Observable<any> {
    return this.apiService.get(
      `${this.path}/getAllEstadoSolicitacaoRenovacaoEnum`
    );
  }

  getAllNivelAcademicoEnum(): Observable<any> {
    return this.apiService.get(`${this.path}/getAllNivelAcademicoEnum`);
  }

  getAllNivelAcademicoMIREMPETEnum(): Observable<any> {
    return this.apiService.get(`${this.path}/getAllNivelAcademicoMIREMPETEnum`);
  }

  getAllTipoProgramaEnum(): Observable<any> {
    return this.apiService.get(`${this.path}/getAllTipoProgramaEnum`);
  }

  getAllTipoDocumentoEnum(): Observable<any> {
    return this.apiService.get(`${this.path}/GetAllTipoDocumentoEnum`);
  }

  getAllSistemaEnum(): Observable<any> {
    return this.apiService.get(`${this.path}/getAllSistemaEnum`);
  }

  getAllNacionalidadeEnum(): Observable<any> {
    return this.apiService.get(`${this.path}/getAllNacionalidadeEnum`);
  }

  getAllEnumPerfilEstudanteEnum(): Observable<any> {
    return this.apiService.get(`${this.path}/getAllEnumPerfilEstudante`);
  }

  getAllEnumEstadoDocumentoEnum(): Observable<any> {
    return this.apiService.get(`${this.path}/getAllEnumEstadoDocumento`);
  }

  getAllEnumAcaoAtivityLogsEnumEnum(): Observable<any> {
    return this.apiService.get(`${this.path}/AcaoAtivityLogsEnum`);
  }

  getAllEnumEntidadeEnum(): Observable<any> {
    return this.apiService.get(`${this.path}/EntidadeEnum`);
  }

  GetAllTipoDocumentoEnum(): Observable<any> {
    return this.apiService.get(`${this.path}/GetAllTipoDocumentoEnum`);
  }

  getAllEnumEstadoDocumento(): Observable<any> {
    return this.apiService.get(`${this.path}/getAllEnumEstadoDocumento`);
  }

  public apiEnumsGetAllEstadoMatriculaEnumGet(
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: undefined;
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const httpOptions = options?.context
      ? { context: options.context }
      : undefined;
    return this.apiService.get(`${this.path}/getAllEstadoMatriculaEnum`);
  }
}
